import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from '../../rootReducer';

export type MessageLevel = 'ERROR' | 'WARN' | 'INFO';

export interface Message {
  content: string;
  level: MessageLevel;
}

export interface MessageList {
  messageList: Message[];
}

const initialState: MessageList = {
  messageList: [],
};

const messageListsSlice = createSlice({
  name: 'messageList',
  initialState,
  reducers: {
    addMessage(state, action: PayloadAction<{content: string; level: MessageLevel}>) {
      const { content, level } = action.payload;
      state.messageList.push({content, level});
    },
  },
});

export const {
  addMessage,
} = messageListsSlice.actions;

export default messageListsSlice.reducer;

export const selectLastMessage = (state: RootState) => {
  const { messageList } = state.messageList;
  if (messageList.length < 1) {
    return null;
  }

  return messageList[messageList.length - 1];
};
